/* =============================================================================
   lp-col-bogo-st-13.js — advertorial BOGO LP behavior (st-13).
   Dependency-free, idempotent. Reuses the shared framework button-loading
   helper (window.BBELP.setLoading) from lp-scripts.js. Scoped per [data-st11-root].

   Behaviors: select-2 BOGO grid, sticky selection bar, 2-step upsell modal
   (add-on + free gift), checkout (POST /cart/add.js then discount redirect chain),
   tap-to-copy code, and toast. Core content + product links work without JS.
============================================================================= */
(function () {
  "use strict";

  if (window.__lpColBogoSt13CoreLoaded) return;
  window.__lpColBogoSt13CoreLoaded = true;

  var SCROLL_THRESHOLD = 200;
  var MAX_SELECT = 2;

  function stickyApi() {
    return window.BBELP && window.BBELP.sticky ? window.BBELP.sticky : null;
  }

  function scrollY() {
    var api = stickyApi();
    if (api) return api.scrollY();
    return Math.max(window.scrollY || 0, window.pageYOffset || 0);
  }

  function scrollThreshold() {
    var api = stickyApi();
    if (api) return api.scrollThreshold(80, SCROLL_THRESHOLD);
    return window.matchMedia("(max-width: 767px)").matches ? 80 : SCROLL_THRESHOLD;
  }

  function scrollToShopSection(el) {
    var api = stickyApi();
    if (api) {
      api.scrollTo(el);
      return;
    }
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function revealSticky(sticky, root) {
    var api = stickyApi();
    if (api) {
      api.reveal(sticky, root);
      return;
    }
    if (!sticky) return;
    sticky.removeAttribute("hidden");
    sticky.hidden = false;
    sticky.classList.add("is-visible");
    if (root) root.classList.add("lp-has-sticky");
  }

  function hideSticky(sticky, root) {
    var api = stickyApi();
    if (api) {
      api.hide(sticky, root);
      return;
    }
    if (!sticky) return;
    sticky.classList.remove("is-visible");
    if (root) root.classList.remove("lp-has-sticky");
    sticky.hidden = true;
    sticky.setAttribute("hidden", "");
  }

  function setLoading(el, on) {
    if (window.BBELP && typeof window.BBELP.setLoading === "function") {
      window.BBELP.setLoading(el, on);
    } else if (el) {
      el.classList.toggle("is-loading", on !== false);
    }
  }

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return "$" + n.toFixed(2);
  }

  function cardData(card) {
    return {
      el: card,
      id: card.getAttribute("data-st11-id"),
      variant: card.getAttribute("data-st11-variant"),
      price: parseInt(card.getAttribute("data-st11-price"), 10) || 0,
      title: card.getAttribute("data-st11-title") || "",
      img: card.getAttribute("data-st11-img") || "",
      available: card.getAttribute("data-st11-available") === "true",
    };
  }

  function init(root) {
    if (root.dataset.st11Bound === "1") return;
    root.dataset.st11Bound = "1";

    /* ---- st-13 campaign extras (benefits / ingredients / stats / glow) ---- */
    try {
      (function () {
        var list = root.querySelector("[data-st13-benefits-rotate]");
        if (!list) return;
        var items = list.querySelectorAll("li");
        if (items.length < 2) return;
        var i = 0;
        items[i].classList.add("is-active");
        if (!window.matchMedia || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        setInterval(function () {
          items[i].classList.remove("is-active");
          i = (i + 1) % items.length;
          items[i].classList.add("is-active");
        }, 3500);
      })();
    } catch (e) {}

    try {
      (function () {
        var searchInput = root.querySelector("[data-st13-ing-search]");
        var ingList = root.querySelector("[data-st13-ing-list]");
        if (!searchInput || !ingList) return;
        var status = root.querySelector("[data-st13-ing-search-status]");
        var accordion = searchInput.closest("details");

        function st13IngGroupText(group) {
          var blob = group.getAttribute("data-st13-ing-search-text");
          if (blob) return blob;
          return (group.innerText || group.textContent || "").toLowerCase();
        }

        function filterSt13Ingredients() {
          var q = (searchInput.value || "").trim().toLowerCase();
          var groups = ingList.querySelectorAll("[data-st13-ing-group]");
          var visible = 0;
          groups.forEach(function (group) {
            var text = st13IngGroupText(group);
            var match = !q || text.indexOf(q) !== -1;
            if (match) {
              group.removeAttribute("hidden");
              visible += 1;
            } else {
              group.setAttribute("hidden", "");
            }
          });
          if (!status) return;
          if (q && groups.length) {
            status.hidden = false;
            status.textContent = visible
              ? visible + " product formula" + (visible === 1 ? "" : "s") + " match your search"
              : "No ingredients match your search";
          } else {
            status.hidden = true;
            status.textContent = "";
          }
        }

        searchInput.addEventListener("input", filterSt13Ingredients);
        searchInput.addEventListener("search", filterSt13Ingredients);
        if (accordion) {
          accordion.addEventListener("toggle", function () {
            if (!accordion.open) {
              searchInput.value = "";
              filterSt13Ingredients();
              return;
            }
            try {
              searchInput.focus({ preventScroll: true });
            } catch (e) {
              searchInput.focus();
            }
          });
        }
      })();
    } catch (e) {}

    try {
      (function () {
        function animateSt13Stat(el) {
          var target = parseFloat(el.getAttribute("data-stat-target"));
          var countEl = el.querySelector("[data-st13-stat-count]");
          if (!countEl || isNaN(target)) return;
          var duration = 1800;
          var startTime = null;
          countEl.textContent = "0";
          function step(ts) {
            if (!startTime) startTime = ts;
            var prog = Math.min((ts - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - prog, 3);
            countEl.textContent = String(Math.floor(eased * target));
            if (prog < 1) requestAnimationFrame(step);
            else countEl.textContent = String(Math.floor(target));
          }
          requestAnimationFrame(step);
        }

        var statItems = root.querySelectorAll(".stat-item[data-stat-target]");
        if (!statItems.length) return;
        if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        if ("IntersectionObserver" in window) {
          var statObs = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                animateSt13Stat(e.target);
                statObs.unobserve(e.target);
              }
            });
          }, { threshold: 0.3 });
          statItems.forEach(function (el) { statObs.observe(el); });
        } else {
          statItems.forEach(animateSt13Stat);
        }
      })();
    } catch (e) {}

    try {
      (function () {
        var glowCards = root.querySelectorAll("[data-st13-glow-card]");
        if (!glowCards.length) return;
        if (!window.matchMedia || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          glowCards.forEach(function (c) { c.classList.add("is-visible"); });
          return;
        }
        if (!("IntersectionObserver" in window)) {
          glowCards.forEach(function (c) { c.classList.add("is-visible"); });
          return;
        }
        var glowObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            e.target.classList.add("is-visible");
            glowObs.unobserve(e.target);
          });
        }, { threshold: 0.15, rootMargin: "0px 0px -8% 0px" });
        glowCards.forEach(function (c, i) {
          c.style.transitionDelay = String(i * 120) + "ms";
          glowObs.observe(c);
        });
      })();
    } catch (e) {}


    var config = {};
    try {
      config = JSON.parse(root.getAttribute("data-st11-config") || "{}");
    } catch (e) {
      config = {};
    }
    var discountCode = config.discountCode || "BOGO";
    var offerCopy = config.offerCopy || "Buy 1, Get 1 Free";

    var selected = []; // grid cards (max 2)

    var rootId = root.id || "";
    var stickyApiFn = stickyApi();
    var sticky = stickyApiFn ? stickyApiFn.resolve(root, rootId) : root.querySelector("[data-lp-sticky]");
    var stickyStatus = sticky ? sticky.querySelector("[data-lp-sticky-status]") : null;
    var stickyThumbs = sticky ? sticky.querySelector("[data-lp-sticky-thumbs]") : null;
    var stickyEmpty = sticky ? sticky.querySelector("[data-lp-sticky-empty]") : null;
    var stickyBadge = sticky ? sticky.querySelector("[data-lp-sticky-badge]") : null;
    var stickyPrice = sticky ? sticky.querySelector("[data-lp-sticky-price]") : null;
    var stickyNow = sticky ? sticky.querySelector("[data-lp-sticky-price-now]") : null;
    var stickyWas = sticky ? sticky.querySelector("[data-lp-sticky-price-was]") : null;
    var stickyCta = sticky ? sticky.querySelector("[data-lp-sticky-cta]") : null;
    var stickyCtaText = sticky ? sticky.querySelector("[data-lp-sticky-cta-text]") : null;
    var stickyThumbsWrap = sticky ? sticky.querySelector(".lp-sticky__thumbs") : null;
    var gridStatus = root.querySelector("[data-st11-grid-status]");
    var tooltip = sticky ? sticky.querySelector("[data-lp-sticky-tooltip]") : null;

    function anchorStickyTooltip() {
      if (!tooltip || !stickyCta) return;
      if (tooltip.parentElement !== stickyCta) {
        stickyCta.appendChild(tooltip);
      }
    }

    anchorStickyTooltip();

    var shop = root.querySelector("#shop") || root.querySelector("[data-st11-sticky-anchor]");
    var toast = root.querySelector("[data-st11-toast]");
    var toastText = root.querySelector("[data-st11-toast-text]");
    var toastTimer = null;
    var stickyMqCompact = window.matchMedia("(max-width: 767px)");

    function showToast(msg, opts) {
      if (!toast) return;
      opts = opts || {};
      var tone = opts.tone === "success" ? "success" : "info";
      if (toastText && msg) toastText.textContent = msg;
      toast.classList.toggle("is-success", tone === "success");
      toast.hidden = false;
      void toast.offsetWidth;
      toast.classList.add("is-visible");
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove("is-visible");
        setTimeout(function () {
          toast.hidden = true;
          toast.classList.remove("is-success");
        }, 240);
      }, 3000);
    }

    function selectionProgressCopy(count) {
      if (count === 0) return "0 of 2 selected";
      if (count === 1) return "1 more to unlock BOGO";
      return "BOGO unlocked!";
    }

    function variantLabelFromCard(card) {
      if (!card) return "";
      var sel = card.querySelector("[data-st11-variant-select]");
      if (!sel || !sel.options.length) return "";
      var opt = sel.options[sel.selectedIndex];
      var variantLabel = (opt.getAttribute("data-variant-label") || opt.textContent || "")
        .replace(/\s*-\s*[^-]+$/, "")
        .replace(/\s*—\s*Sold out\s*$/, "")
        .trim();
      if (!variantLabel || variantLabel === "Default Title") return "";
      return variantLabel;
    }

    function selectionLabelFromCard(card) {
      if (!card) return "";
      var title = card.getAttribute("data-st11-title") || "";
      var variant = variantLabelFromCard(card);
      return variant ? title + " (" + variant + ")" : title;
    }

    function buildTooltipMessage(triggerCard) {
      if (selected.length >= MAX_SELECT) {
        return (
          "Selected: " +
          selectionLabelFromCard(selected[0].el) +
          " + " +
          selectionLabelFromCard(selected[1].el)
        );
      }
      if (triggerCard) {
        return "Selected: " + selectionLabelFromCard(triggerCard);
      }
      if (!selected.length) return "";
      return "Selected: " + selectionLabelFromCard(selected[0].el);
    }

    var tooltipTimer = null;

    function stickyStatusCopy(count) {
      if (count < MAX_SELECT) return offerCopy;
      if (stickyMqCompact.matches) return "";
      return "1 item free with code " + discountCode;
    }

    function updateStickyStatusPresentation(count) {
      if (!stickyStatus) return;
      var isReady = count >= MAX_SELECT;
      stickyStatus.classList.toggle("is-offer-pulse", count < MAX_SELECT);
      stickyStatus.hidden = isReady && stickyMqCompact.matches;
    }

    function updateGridStatus(count) {
      if (!gridStatus) return;
      gridStatus.textContent = selectionProgressCopy(count);
      gridStatus.classList.toggle("is-unlocked", count >= MAX_SELECT);
    }

    function updateSticky() {
      var count = selected.length;
      var isReady = count >= MAX_SELECT;
      if (sticky) sticky.classList.toggle("is-bogo-ready", isReady);
      if (stickyCta) stickyCta.classList.toggle("is-bogo-ready", isReady);
      if (stickyThumbsWrap) stickyThumbsWrap.classList.toggle("is-bogo-ready", isReady);
      if (stickyThumbs) {
        stickyThumbs.innerHTML = "";
        selected.forEach(function (c) {
          if (!c.img) return;
          var im = document.createElement("img");
          im.src = c.img;
          im.alt = "";
          stickyThumbs.appendChild(im);
        });
      }
      if (stickyEmpty) {
        stickyEmpty.hidden = count > 0;
      }
      if (stickyBadge) {
        stickyBadge.textContent = String(count);
        stickyBadge.classList.toggle("is-active", count > 0);
      }

      if (count === 0) {
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(0);
        if (stickyPrice) stickyPrice.hidden = true;
        if (stickyCtaText) stickyCtaText.textContent = "Select products";
      } else if (count === 1) {
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(1);
        if (stickyPrice) stickyPrice.hidden = true;
        if (stickyCtaText) stickyCtaText.textContent = "Select 1 More";
      } else {
        var total = selected[0].price + selected[1].price;
        var freeAmt = Math.min(selected[0].price, selected[1].price);
        var pay = total - freeAmt;
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(2);
        if (stickyPrice) {
          stickyPrice.hidden = false;
          if (stickyNow) stickyNow.textContent = money(pay);
          if (stickyWas) stickyWas.textContent = money(total);
        }
        if (stickyCtaText) stickyCtaText.textContent = "CLAIM NOW";
      }

      updateStickyStatusPresentation(count);
      updateGridStatus(count);

      function shopSectionVisible() {
        if (!shop) return false;
        var r = shop.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      }

      var show = count >= 1 || scrollY() > scrollThreshold() || shopSectionVisible();
      if (sticky) {
        if (show) {
          revealSticky(sticky, root);
        } else {
          hideSticky(sticky, root);
        }
      }
    }

    function showTooltip(triggerCard) {
      if (!tooltip) return;
      anchorStickyTooltip();
      var msg = buildTooltipMessage(triggerCard);
      if (!msg) return;
      tooltip.textContent = msg;
      tooltip.hidden = false;
      if (tooltipTimer) clearTimeout(tooltipTimer);
      tooltipTimer = setTimeout(function () {
        if (tooltip) tooltip.hidden = true;
      }, 3200);
    }

    function filterReviews(key) {
      var chips = root.querySelectorAll("[data-st11-rev-filter]");
      for (var i = 0; i < chips.length; i++) {
        chips[i].setAttribute(
          "aria-pressed",
          chips[i].getAttribute("data-st11-rev-filter") === key ? "true" : "false"
        );
      }
      var cards = root.querySelectorAll("[data-st11-review]");
      var shown = 0;
      for (var j = 0; j < cards.length; j++) {
        var match = key === "all" || cards[j].getAttribute("data-st11-skin") === key;
        cards[j].hidden = !match;
        if (match) shown++;
      }
      var countEl = root.querySelector("[data-st11-rev-count]");
      if (countEl) {
        countEl.textContent = "Showing " + shown + " review" + (shown === 1 ? "" : "s");
      }
    }

    function initCountdown() {
      var el = root.querySelector("[data-st11-countdown]");
      if (!el) return;
      var timeEl = el.querySelector("[data-st11-countdown-time]");
      if (!timeEl) return;
      var mins = parseInt(el.getAttribute("data-st11-countdown-mins"), 10) || 15;
      var storeKey = "st11_cd_" + (root.id || "lp");
      var timerId = null;
      var now = Date.now();
      var end = parseInt(sessionStorage.getItem(storeKey), 10);
      if (!end || isNaN(end) || end < now) {
        end = now + mins * 60 * 1000;
        try {
          sessionStorage.setItem(storeKey, String(end));
        } catch (e) {}
      }
      function pad(n) {
        return n < 10 ? "0" + n : "" + n;
      }
      function render() {
        var diff = end - Date.now();
        if (diff <= 0) {
          timeEl.textContent = "00:00";
          return;
        }
        var total = Math.floor(diff / 1000);
        var h = Math.floor(total / 3600);
        var m = Math.floor((total % 3600) / 60);
        var s = total % 60;
        timeEl.textContent = (h > 0 ? pad(h) + ":" : "") + pad(m) + ":" + pad(s);
      }
      function schedule() {
        if (timerId) clearTimeout(timerId);
        render();
        if (end - Date.now() <= 0) return;
        timerId = setTimeout(schedule, 1000);
      }
      render();
      if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        schedule();
      }
    }

    function selectionIndicesForCard(card) {
      var indices = [];
      for (var i = 0; i < selected.length; i++) {
        if (selected[i].el === card) indices.push(i);
      }
      return indices;
    }

    function cardSelectionCount(card) {
      return selectionIndicesForCard(card).length;
    }

    function removeLastSelectionForCard(card) {
      for (var i = selected.length - 1; i >= 0; i--) {
        if (selected[i].el === card) {
          selected.splice(i, 1);
          return true;
        }
      }
      return false;
    }

    function addSelectionForCard(card) {
      if (card.getAttribute("data-st11-available") !== "true") return false;
      var cardCount = cardSelectionCount(card);
      if (cardCount >= 2) return false;
      if (selected.length >= MAX_SELECT) {
        showToast("Deselect an item to swap your pick");
        return false;
      }
      selected.push(cardData(card));
      if (cardCount === 0) {
        card.setAttribute("data-st11-bogo-phase", "first");
      } else if (selected.length === MAX_SELECT) {
        card.setAttribute("data-st11-bogo-phase", "both");
      }
      return true;
    }

    function decrementCard(card) {
      if (!removeLastSelectionForCard(card)) return;
      var cardCount = cardSelectionCount(card);
      if (cardCount === 0) {
        card.removeAttribute("data-st11-bogo-phase");
      } else if (cardCount === 1 && card.getAttribute("data-st11-bogo-phase") === "both") {
        card.setAttribute("data-st11-bogo-phase", "one-after-both");
      }
      refreshGridCards();
      updateSticky();
    }

    function incrementCard(card) {
      if (addSelectionForCard(card)) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    function refreshGridCards() {
      var cards = root.querySelectorAll('[data-st11-card][data-st11-mode="select"]');
      cards.forEach(function (card) {
        var slotIndices = selectionIndicesForCard(card);
        var cardCount = slotIndices.length;
        var isSel = cardCount > 0;
        var isFree = slotIndices.indexOf(1) > -1;
        card.classList.toggle("is-selected", isSel);
        card.classList.toggle("is-free", isFree);
        card.setAttribute("aria-pressed", isSel ? "true" : "false");
        if (!isSel) card.removeAttribute("data-st11-bogo-phase");

        var btn = card.querySelector("[data-st11-toggle]");
        var txt = card.querySelector("[data-st11-btn-text]");
        var btnCheck = card.querySelector("[data-st11-btn-check]");
        var qtyWrap = card.querySelector("[data-st11-qty]");
        var qtyCount = card.querySelector("[data-st11-qty-count]");
        var qtyMinus = card.querySelector("[data-st11-qty-minus]");
        var qtyPlus = card.querySelector("[data-st11-qty-plus]");
        var slotsFullElsewhere = selected.length >= MAX_SELECT && cardCount < 2;

        if (btn) {
          btn.hidden = isSel;
          btn.setAttribute("aria-pressed", isSel ? "true" : "false");
        }
        if (qtyWrap) {
          qtyWrap.hidden = !isSel;
          qtyWrap.setAttribute("aria-hidden", isSel ? "false" : "true");
        }
        if (qtyCount) qtyCount.textContent = String(cardCount);
        if (qtyMinus) qtyMinus.disabled = cardCount <= 0;
        if (qtyPlus) {
          qtyPlus.disabled = cardCount >= 2 || slotsFullElsewhere;
        }
        if (btnCheck) btnCheck.hidden = !isSel;
        if (txt && btn && !isSel) {
          txt.textContent = btn.getAttribute("data-st11-base-label") || "Select";
        }

        var label = card.querySelector("[data-st11-selected-label]");
        if (label) {
          if (!isSel) {
            label.textContent = "";
          } else if (cardCount >= 2) {
            label.textContent = "\u00d72";
          } else {
            label.textContent = String(slotIndices[0] + 1);
          }
        }

        var freeNow = card.querySelector("[data-st11-free-now]");
        if (freeNow) freeNow.hidden = !isFree;
      });
    }

    function toggleSelect(card) {
      if (card.getAttribute("data-st11-available") !== "true") return;
      var cardCount = cardSelectionCount(card);
      if (cardCount > 0) return;
      if (selected.length >= MAX_SELECT) {
        showToast("Deselect an item to swap your pick");
        return;
      }
      if (addSelectionForCard(card)) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    function selectionToCartItems(selections) {
      var qtyByVariant = {};
      selections.forEach(function (c) {
        var id = Number(c.variant);
        qtyByVariant[id] = (qtyByVariant[id] || 0) + 1;
      });
      return Object.keys(qtyByVariant).map(function (id) {
        return { id: Number(id), quantity: qtyByVariant[id] };
      });
    }

    var modalApi = null;

    function ensureModalApi() {
      if (modalApi) return modalApi;
      if (!(window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.init === "function")) {
        return null;
      }
      modalApi = window.BBELP.modal.init({
        root: root,
        getParentVariantIds: function () {
          return selected.map(function (s) {
            return Number(s.variant);
          });
        },
        getParentProductIds: function () {
          return selected.map(function (s) {
            return Number(s.id);
          });
        },
        getParentCartItems: function () {
          return selectionToCartItems(selected);
        },
        canCheckout: function () {
          return selected.length >= MAX_SELECT;
        },
        onCheckoutBlocked: function () {
          showToast("Please select 2 products first");
        },
        onStickySuppress: function (on) {
          if (stickyApiFn) stickyApiFn.suppress(on);
        },
      });
      return modalApi;
    }

    function openModal() {
      var api = ensureModalApi();
      if (api && typeof api.open === "function") {
        api.open();
        return;
      }
      if (window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.open === "function") {
        ensureModalApi();
        window.BBELP.modal.open();
        return;
      }
      showToast("Please tap CLAIM NOW again");
    }

    window.setTimeout(function () {
      ensureModalApi();
    }, 0);

    root.addEventListener("bbe:lp-upsells:checkoutBlocked", function (e) {
      var reason = e.detail && e.detail.reason;
      if (reason === "upsell_required_for_gift" || reason === "upsell_required") {
        showToast("Please select an add-on item first");
        return;
      }
      showToast("Please select 2 products first");
    });

    /* ---- events ---- */
    root.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var card = e.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (!card || !root.contains(card)) return;
      if (e.target.closest("select, button, [data-st11-variant-select], [data-st11-toggle], [data-st11-qty-minus], [data-st11-qty-plus]")) return;
      e.preventDefault();
      toggleSelect(card);
    });

    root.addEventListener("click", function (e) {
      var qtyMinus = e.target.closest("[data-st11-qty-minus]");
      if (qtyMinus && root.contains(qtyMinus)) {
        var minusCard = qtyMinus.closest("[data-st11-card]");
        if (minusCard && minusCard.getAttribute("data-st11-mode") === "select") {
          decrementCard(minusCard);
        }
        return;
      }

      var qtyPlus = e.target.closest("[data-st11-qty-plus]");
      if (qtyPlus && root.contains(qtyPlus)) {
        var plusCard = qtyPlus.closest("[data-st11-card]");
        if (plusCard && plusCard.getAttribute("data-st11-mode") === "select") {
          incrementCard(plusCard);
        }
        return;
      }

      var toggle = e.target.closest("[data-st11-toggle]");
      if (toggle && root.contains(toggle)) {
        var card = toggle.closest("[data-st11-card]");
        if (!card) return;
        if (card.getAttribute("data-st11-mode") === "select") {
          toggleSelect(card);
        }
        return;
      }

      /* Main grid: entire card toggles selection (select mode only) */
      var gridCard = e.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (gridCard && root.contains(gridCard)) {
        if (e.target.closest("select, button, [data-st11-variant-select], [data-st11-toggle], [data-st11-qty-minus], [data-st11-qty-plus]")) return;
        e.preventDefault();
        toggleSelect(gridCard);
        return;
      }

      if (e.target.closest("[data-st11-cta-scroll], [data-lp-listicle-scroll]")) {
        if (selected.length === MAX_SELECT) {
          openModal();
        } else {
          scrollToShopSection(shop);
        }
        return;
      }

      var revFilter = e.target.closest("[data-st11-rev-filter]");
      if (revFilter && root.contains(revFilter)) {
        filterReviews(revFilter.getAttribute("data-st11-rev-filter"));
        return;
      }

      var copyBtn = e.target.closest("[data-st11-copy-code], [data-lp-copy-code]");
      if (copyBtn) {
        var code = copyBtn.getAttribute("data-st11-code") || copyBtn.getAttribute("data-lp-code") || discountCode;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(
            function () {
              showToast("Code " + code + " copied", { tone: "success" });
            },
            function () {
              showToast("Code: " + code);
            }
          );
        } else {
          showToast("Code: " + code);
        }
        return;
      }
    });

    function applyVariantSelect(sel) {
      var card = sel.closest("[data-st11-card]");
      if (!card || card.getAttribute("data-st11-mode") !== "select") return;
      var opt = sel.options[sel.selectedIndex];
      var price = parseInt(opt.getAttribute("data-price"), 10) || 0;
      var compare = parseInt(opt.getAttribute("data-compare"), 10) || 0;
      card.setAttribute("data-st11-variant", opt.value);
      card.setAttribute("data-st11-price", price);
      card.setAttribute("data-st11-compare", compare);
      var nowEl = card.querySelector("[data-st11-price-display]");
      if (nowEl) nowEl.textContent = money(price);
      var compareEl = card.querySelector("[data-st11-compare-display]");
      if (compareEl) compareEl.textContent = compare > price ? money(compare) : "";
      var data = cardData(card);
      var touched = false;
      for (var si = 0; si < selected.length; si++) {
        if (selected[si].el === card) {
          selected[si] = data;
          touched = true;
        }
      }
      if (touched) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    root.addEventListener("change", function (e) {
      var sel = e.target.closest("[data-st11-variant-select]");
      if (!sel || !root.contains(sel)) return;
      applyVariantSelect(sel);
    });

    function onStickyCtaClick(e) {
      e.preventDefault();
      if (selected.length === MAX_SELECT) {
        openModal();
      } else {
        scrollToShopSection(shop);
      }
    }

    if (root.dataset.st11StickyDocClick !== "1") {
      root.dataset.st11StickyDocClick = "1";
      document.addEventListener("click", function (e) {
        if (!e.target.closest("[data-lp-sticky-cta]")) return;
        var bar = e.target.closest("[data-lp-sticky]");
        if (!bar || bar.getAttribute("data-lp-sticky-root-id") !== rootId) return;
        onStickyCtaClick(e);
      });
    }

    function onScrollUpdate() {
      updateSticky();
    }
    var scrollOpts = { passive: true };
    window.addEventListener("scroll", onScrollUpdate, scrollOpts);
    document.addEventListener("scroll", onScrollUpdate, scrollOpts);
    if (document.documentElement) {
      document.documentElement.addEventListener("scroll", onScrollUpdate, scrollOpts);
    }
    var scrollRoot = document.getElementById("MainContent");
    if (scrollRoot) {
      scrollRoot.addEventListener("scroll", onScrollUpdate, scrollOpts);
    }

    if (typeof stickyMqCompact.addEventListener === "function") {
      stickyMqCompact.addEventListener("change", updateSticky);
    } else if (typeof stickyMqCompact.addListener === "function") {
      stickyMqCompact.addListener(updateSticky);
    }

    // Year auto-fill (footer copyright is server-rendered; this is a safety net)
    root.querySelectorAll("[data-st11-year]").forEach(function (el) {
      el.textContent = String(new Date().getFullYear());
    });

    initCountdown();
    updateSticky();
    requestAnimationFrame(updateSticky);
  }

  function boot() {
    document.querySelectorAll("[data-st11-root]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  // Re-init in Shopify theme editor when the section is re-rendered.
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector
      ? e.target.querySelector("[data-st11-root]")
      : null;
    if (root) {
      root.dataset.st11Bound = "";
      init(root);
    }
  });
})();
